import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'

import { precision } from 'helpers/formatters'

import { stage } from 'types/RuntimeHistory'

type props = {
  stage: stage
}

const Stage = ({ stage }: props) => {
  return (
    <Table.Row>
      <S.StageNameCell>
        <S.ColorBox color={stage.color} />
        <span>{stage.name}</span>
      </S.StageNameCell>
      <S.Cell>{stage.cycleCount}</S.Cell>
      <S.Cell>{precision(stage.runtimeMinutes, 0)}</S.Cell>
    </Table.Row>
  )
}

export default Stage

const cellStyle = css`
  font-size: 14px;
  align-items: center;
  flex: 1;
  padding: 10px;
  text-transform: capitalize;
`

const S = {
  Cell: styled(Table.Cell)`
    ${cellStyle}
  `,
  StageNameCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 2;
  `,
  ColorBox: styled.div.withConfig({
    shouldForwardProp: (prop) => !['color'].includes(prop)
  })<{ color: string }>`
    height: 10px;
    width: 10px;
    margin: 0px 10px 0px 20px;
    background-color: ${({ color }) => color};
  `
}
